import { Component, OnInit } from '@angular/core';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { AirSpaceBoundaryModel } from 'src/app/models/air-space-boundary';
import { AirSpaceBoundaryCoordinatePointModel } from 'src/app/models/air-space-boundary-coordinate-point';
import { AirSpaceBoundaryVertexLineModel } from 'src/app/models/AirSpaceBoundaryVertexLine';
import { SelectCoordinatePointsControlService } from 'src/app/popup/services/select-coordinate-points-control.service';
import { AirSpaceBoundaryFilterService } from 'src/app/services/air-space-bondary-filter.service';
import { AirspaceBoundariesControlService } from 'src/app/services/airspace-boundaries-control.service';
import { PointsService } from 'src/app/services/points.service';
import { TabsService } from 'src/app/services/tabsService';
import { ToolsControlService } from 'src/app/services/tools-control.service';

@Component({
  selector: 'app-airspace-boundaries-filter',
  templateUrl: './airspace-boundaries-filter.component.html',
  styleUrls: ['./airspace-boundaries-filter.component.scss'],
  standalone: false
})
export class AirspaceBoundariesFilterComponent implements OnInit {


  selectedAirSpaceBoundary: AirSpaceBoundaryModel;

  constructor( public airspaceFilterController : AirSpaceBoundaryFilterService,
    public menuController : MenuManagementService,
    private toolsService : ToolsControlService,
    private pointsService : PointsService,
    public  selectCoordinatePointService : SelectCoordinatePointsControlService,
    public airspaceBoundaryController: AirspaceBoundariesControlService,
    public tabsService : TabsService
    ) { }

  ngOnInit(): void {
  }

  cancelWindow():void{
    this.airspaceFilterController.active = !this.airspaceFilterController.active;
    this.toolsService.navigationOnTop = false;
  }


  anotherProc(airspace: AirSpaceBoundaryModel) {
    console.log(airspace);
  }




  addToMap() : void {
    let selectedAirspaceBoundaries : AirSpaceBoundaryModel[] = [];

    this.airspaceBoundaryController.airspaceBoundaires.forEach( asb => {
      if(asb.isselected) {
        asb.mapstatus = true;
        selectedAirspaceBoundaries.push(asb);
        this.fillLegs(asb);
      }
    });
    this.airspaceBoundaryController.bulkUpdateAirspaceBoundaries(selectedAirspaceBoundaries);
  }

  fillLegs( airspaceBoundary : AirSpaceBoundaryModel ): void {
    let lineId = 0;
    airspaceBoundary.airSpaceBoundaryLines = [];

    if(airspaceBoundary.airSpaceBoundaryCoordinatePoints.length > 2){
      let startPoint : AirSpaceBoundaryCoordinatePointModel = new AirSpaceBoundaryCoordinatePointModel();

      startPoint.altitude = 0;
      startPoint.coordPoint = airspaceBoundary.airSpaceBoundaryCoordinatePoints[0].coordPoint;

      for(var index:number = 1; index < airspaceBoundary.airSpaceBoundaryCoordinatePoints.length; index++) {

        let currentPoint : AirSpaceBoundaryCoordinatePointModel = new AirSpaceBoundaryCoordinatePointModel();
        currentPoint.coordPoint = airspaceBoundary.airSpaceBoundaryCoordinatePoints[index].coordPoint;
        currentPoint.altitude = currentPoint.coordPoint.minaltitude;

        //first leg connects to the first element in array
        if (index === 1) {
          let middleLeg: AirSpaceBoundaryVertexLineModel = new AirSpaceBoundaryVertexLineModel();
          middleLeg.isstraightleg = true;
          middleLeg.startPoint = startPoint;
          middleLeg.endPoint = currentPoint;
          middleLeg.id = `l${lineId++}`;

         this.selectCoordinatePointService.addLineToMap(middleLeg, airspaceBoundary);
         airspaceBoundary.airSpaceBoundaryLines.push(middleLeg);

        } else {
          let previousPoint : AirSpaceBoundaryCoordinatePointModel = new AirSpaceBoundaryCoordinatePointModel();

          previousPoint.altitude = 0;
          previousPoint.coordPoint = airspaceBoundary.airSpaceBoundaryCoordinatePoints[index-1].coordPoint;


          let middleLeg: AirSpaceBoundaryVertexLineModel = new AirSpaceBoundaryVertexLineModel();
          middleLeg.isstraightleg = true;
          middleLeg.startPoint = previousPoint;
          middleLeg.endPoint = currentPoint;
          middleLeg.id = `l${lineId++}`;

          this.selectCoordinatePointService.addLineToMap(middleLeg, airspaceBoundary);
          airspaceBoundary.airSpaceBoundaryLines.push(middleLeg);
        }

        //the last element always connects back to the first elemment
        if (index === airspaceBoundary.airSpaceBoundaryCoordinatePoints.length - 1) {

          let lastLeg: AirSpaceBoundaryVertexLineModel = new AirSpaceBoundaryVertexLineModel();
          lastLeg.isstraightleg = true;
          lastLeg.startPoint = currentPoint;
          lastLeg.endPoint = startPoint;
          lastLeg.id = `l${lineId++}`;
          airspaceBoundary.airSpaceBoundaryLines.push(lastLeg);

          break;
        }
      }
    }
  }

  removeFromMap() : void {
    let selectedAirspaceBoundaries : AirSpaceBoundaryModel[] = [];

    this.airspaceBoundaryController.airspaceBoundaires.forEach( asb => {
      if(asb.isselected) {
        asb.mapstatus = false;
        selectedAirspaceBoundaries.push(asb);
        this.fillLegs(asb);
      }

    });
    this.airspaceBoundaryController.bulkUpdateAirspaceBoundaries(selectedAirspaceBoundaries);

  }

  deselectAll() {
    this.airspaceBoundaryController.airspaceBoundaires.forEach( asb => {
      asb.isselected = false;

    });
  }
  selectAll() {
    this.airspaceBoundaryController.airspaceBoundaires.forEach( asb => {
      asb.isselected = true;
    });
  }

}
